
<main class="main-dashboard">
    <article class="main-canvas">
        <section class="canvas-container">
            <section class="dashboard-items">
                <div class="canvas-item">
                    <div class="canvas-header row justify-content-between align-items-center" >
                        <div class="title col-sm-6">
                            <h3>Onboarding Approval</h3>
                        </div>
                        <div class="col-sm-6 d-flex justify-content-end">
                            <div class="edit" *ngIf="selectedCheckboxData.length === 1">
                              <button type="button" title="Edit" (click)="editOpenModal()" data-bs-toggle="modal" data-bs-target="#timesheet">
                                <span><i class="ri-pencil-line"></i></span>
                              </button>
                            </div>
                          </div>
                    </div>
                    <ag-grid-angular 
                          style="height: calc(100vh - 120px) !important;" 
                           class="ag-theme-material"
                           (gridReady)="onGridReady($event)"
                           [rowData]="rowData"
                           [columnDefs]="columnDefs"
                           pagination="true"
                           [defaultColDef]="defaultColDef"
                           [suppressRowClickSelection]="true"
                           [rowSelection]="rowSelection"
                           (selectionChanged)="onSelectionChanged($event)"
                           paginationPageSize=10>
                    </ag-grid-angular>
                </div>
            </section>
        </section>
    </article>
</main>

<!-- Approve OnBoarding -->
<div class="modal fade" id="approveUser" tabindex="-1">
    <div class="modal-dialog">
        <div class="modal-content pl-5 pr-5">
            <form [formGroup]="">
                <div class="modal-header">
                    <h5 class="modal-title">Are you sure?</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>
                <div class="modal-body">
                  <div class="text-center">
                    <p>Are you sure you want to proceed with user Onboarding?</p>
                  </div>
                  <div class="d-flex gap-4 w-100 justify-content-around">
                    <button type="button"  class="btn btn-primary" data-bs-dismiss="modal" (click)="approveUser()">Yes</button>
                    <button type="button" class="btn btn-secondary">No</button>
                  </div>
           
                </div>
            </form>
        </div>
    </div>
  </div>

  <div class="modal fade" id="cancelConfirmation" tabindex="-1">
    <div class="modal-dialog">
        <div class="modal-content pl-5 pr-5">
            <form [formGroup]="">
                <div class="modal-header">
                    <h5 class="modal-title">Are you sure?</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>
                <div class="modal-body">
                  <div class="text-center">
                    <p>Are you sure? You want to cancel this request?</p>
                  </div>
                  <div class="d-flex gap-4 w-100 justify-content-around">
                    <button type="button"  class="btn btn-primary" data-bs-dismiss="modal" (click)="cancelUserOnboarding()">Yes</button>
                    <button type="button" class="btn btn-secondary">No</button>
                  </div>
           
                </div>
            </form>
        </div>
    </div>
  </div>

  <button type="button"  data-bs-toggle="modal" data-bs-target="#approveUser" id="confimationBtn" style="display: none;">
                                 
  </button>

  <button type="button"  data-bs-toggle="modal" data-bs-target="#cancelConfirmation" id="cancelConfirmationBtn" style="display: none;">
                                 
  </button>


  <div class="modal fade bd-example-modal-lg" id="timesheet" tabindex="-1">
    <div class="modal-dialog modal-lg">
        <div class="modal-content pl-5 pr-5">
            <form [formGroup]="userCreationForm">
                <div class="modal-header">
                    <h5 class="modal-title">User Info</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>
                <div class="users-tabls">
                    <nav>
                        <div  class="nav nav-tabs d-flex justify-content-center mb-2" id="nav-tab" >
                       
                            <a
                            class="nav-item nav-link active p-2"
                            id="nav-home-tab"
                            data-toggle="tab"
                            href="#nav-home"
                            role="tab"
                            >HR</a
                          >

                          <a
                            class="nav-item nav-link p-2"
                            id="nav-profile-tab"
                            data-toggle="tab"
                            href="#nav-profile"
                            role="tab"
                            >NDA</a
                            >

                            <a
                                class="nav-item nav-link p-2"
                                id="nav-contact-tab"
                                data-toggle="tab"
                                href="#nav-contact"
                                role="tab"
                                >IT</a
                                >
                        </div>
                    </nav>
                    <div class="tab-content pt-2" id="nav-tabContent">
                        <div class="tab-pane fade show active" id="nav-home" role="tabpanel">
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="input">
                                        <div class="input-item">
                                            <input type="text" formControlName="firstName" required/>
                                            <label class="floating-label-special ">Employee First Name*</label>
                                            <i class="ri-user-line"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="input">
                                        <div class="input-item">
                                            <input type="text" formControlName="middleName" required/>
                                            <label class="floating-label-special">Employee Middle Name*</label>
                                            <i class="ri-user-line"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="input">
                                        <div class="input-item">
                                            <input type="text" formControlName="lastName" required/>
                                            <label class="floating-label-special">Employee Last Name*</label>
                                            <i class="ri-user-line"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="input">
                                        <div class="input-item">
                                            <input type="text" formControlName="displayName" required/>
                                            <label class="floating-label-special" for="displayName">Display Name*</label>
                                            <i class="ri-user-line"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="input">
                                        <div class="input-item">
                                            <input type="text" formControlName="alternateEmailId" required/>
                                            <label class="floating-label-special">Personal Email*</label>
                                            <i class="ri-mail-line"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="input">
                                        <div class="input-item">
                                            <input type="text" formControlName="phoneNo" required/>
                                            <label class="floating-label-special">Contact Number</label>
                                            <i class="ri-smartphone-line"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="input">
                                        <div class="input-item">
                                            <input formControlName="birthDate" type="date"  />
                                            <label for="birthDate" class="floating-label-special">Birth Date*</label>
                                            <i class="ri-file-user-line"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <h5>Company Information</h5>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="input">
                                        <div class="input-item">
                                            <input type="text" formControlName="localId"/>
                                            <label class="floating-label-special">Employee Id*</label>
                                            <i class="ri-code-box-line"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="input">
                                        <div class="input-item">
                                            <input type="text" formControlName="userId"/>
                                            <label class="floating-label-special">User Id</label>
                                            <i class="ri-code-box-line"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="input">
                                        <div class="input-item">
                                            <input type="text" formControlName="currentDesignation"/>
                                            <label class="floating-label-special">Designation</label>
                                            <i class="ri-file-list-line"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="input">
                                        <div class="input-item">
                                            <input type="text" formControlName="department"/>
                                            <label class="floating-label-special">Department</label>
                                            <i class="ri-file-list-line"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="input">
                                        <div class="input-item">
                                            <input type="date" formControlName="joinDate"/>
                                            <label class="floating-label-special">Joining Date</label>
                                            <i class="ri-calendar-2-line"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <h5>Other Information</h5>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="input">
                                        <div class="input-item">
                                            <select formControlName="status" disabled>
                                                <option value="" disabled selected>Select Status</option>
                                                <option value="withHrTeam">With Hr Team</option>
                                                <option value="withNDATeam">With NDA Team</option>
                                                <option value="withItTeam">With IT Team</option>
                                                <option value="waitingForApproval">Waiting For Approval</option>
                                                <option value="approved">Approved</option>
                                            </select>
                                            <label class="floating-label-special">Status</label>
                                            <i class="ri-file-list-line"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="input">
                                        <div class="input-item">
                                            <input type="text" formControlName="location"/>
                                            <label class="floating-label-special">Location</label>
                                            <i class="ri-map-pin-line"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="input">
                                        <div class="input-item">
                                            <input list="taskOwnerDatalist" formControlName="supervisonName"/>
                                            <label class="floating-label-special">Supervisor</label>
                                            <i class="ri-user-line"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="input">
                                        <div class="input-item">
                                            <input list="taskOwnerDatalist" formControlName="managerName"/>
                                            <label class="floating-label-special">Manager Name</label>
                                            <i class="ri-user-line"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="input">
                                        <div class="input-item">
                                            <select formControlName="emailIdRequired" disabled>
                                                <option value="" disabled selected>Email ID Required</option>
                                                <option [ngValue]="true">Yes</option>
                                                <option [ngValue]="false">No</option>
                                              </select>
                                              <label class="floating-label-special">Email ID Required</label>
                                              <i class="ri-file-list-line"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="input">
                                        <div class="input-item">
                                            <select formControlName="permanentOrContractor" disabled>
                                                <option value="" disabled selected>Employment Contract</option>
                                                <option value="Permanent">Permanent</option>
                                                <option value="Contractor">Contractor</option>
                                              </select>
                                              <label class="floating-label-special">Employment Contract</label>
                                            <i class="ri-phone-line"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="input">
                                        <div class="input-item">
                                            <select formControlName="systemRequiredBoolean" disabled>
                                                <option value="" disabled selected>System Required</option>
                                                <option [ngValue]="true">Yes</option>
                                                <option [ngValue]="false">No</option>
                                              </select>
                                              <label class="floating-label-special">System Required</label>
                                            <i class="ri-phone-line"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="input">
                                        <div class="input-item">
                                            <select formControlName="systemRequired" disabled>
                                                <option value="" disabled selected>Select System Type</option>
                                                <option value="Workstation">Workstation</option>
                                                <option value="Laptop">Laptop</option>
                                            </select>
                                            <label class="floating-label-special">System Type*</label>
                                            <i class="ri-user-line"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="tab-pane fade" id="nav-profile" role="tabpanel">
                            <div class="row">
                                <div class="row">
                                    <div class="col-sm-6">
                                        <h5>Personal Information</h5>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="input">
                                        <div class="input-item">
                                             <input type="text" value="{{this.userFullName}}" disabled/> 
                                            <label class="floating-label-special">Full Name</label>
                                            <i class="ri-user-line"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="input">
                                        <div class="input-item">
                                             <input type="text" value="{{this.userFullName}}" disabled/> 
                                            <label class="floating-label-special">Full Name</label>
                                            <i class="ri-user-line"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <h5>NDA Information</h5>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <div class="input">
                                        <div class="input-item">
                                            <select formControlName="ndaSignedBoolean" disabled>
                                                <option value="" disabled selected>NDA Sign</option>
                                                <option [ngValue]="true">Yes</option>
                                                <option [ngValue]="false">No</option>
                                              </select>
                                              <label class="floating-label-special">NDA Sign*</label>
                                              <i class="ri-file-list-line"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="input">
                                        <div class="input-item">
                                            <input type="date" formControlName="ndaSignedDate" disabled/>
                                            <label class="floating-label-special">NDA Sign Date</label>
                                            <i class="ri-user-line"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="input"></div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="input"></div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="input"></div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="input"></div>
                                </div>
                            </div>
                        </div>
                        <div class="tab-pane fade" id="nav-contact" role="tabpanel">
                            <div class="row">
                                <div class="row">
                                    <div class="col-sm-12">
                                      <h5>Personal Information</h5>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="input">
                                        <div class="input-item">
                                            <input type="text" formControlName="userId" />
                                            <label class="floating-label-special">New User</label>
                                            <i class="ri-user-line"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="input">
                                        <div class="input-item">
                                             <input type="text" value="{{this.userFullName}}" disabled/> 
                                            <label class="floating-label-special">Full Name</label>
                                            <i class="ri-user-line"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="input">
                                        <div class="input-item">
                                            <select formControlName="passwordBoolean">
                                                <option value="" disabled selected>Select Password</option>
                                                <option [ngValue]="true">Yes</option>
                                                <option [ngValue]="false">No</option>
                                              </select>
                                              <label class="floating-label-special">Password</label>
                                              <i class="ri-user-line"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="input">
                                        <div class="input-item">
                                            <input type="text" formControlName="emailId" />
                                            <label class="floating-label-special">Email Id</label>
                                            <i class="ri-user-line"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="row">
                                    <div class="col-sm-6">
                                      <h5>Company Information</h5>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="input">
                                        <div class="input-item">
                                            <input type="text" formControlName="localId" />
                                            <label class="floating-label-special">Emp Id</label>
                                            <i class="ri-user-line"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="input">
                                        <div class="input-item">
                                            <input type="text" formControlName="domainUserId" />
                                            <label class="floating-label-special">Domain User ID</label>
                                            <i class="ri-user-line"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="input">
                                        <div class="input-item">
                                            <input type="text" formControlName="requestedDate" />
                                            <label class="floating-label-special">User ID Creation Date</label>
                                            <i class="ri-user-line"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="input">
                                        <div class="input-item">
                                            <select formControlName="status" required>
                                                <option value="" disabled selected>Select Status</option>
                                                <option value="withHrTeam">With Hr Team</option>
                                                <option value="withNDATeam">With NDA Team</option>
                                                <option value="withItTeam">With IT Team</option>
                                                <option value="waitingForApproval">Waiting For Approval</option>
                                                <option value="approved">Approved</option>
                                            </select>
                                              <label class="floating-label-special">Status*</label>
                                              <i class="ri-file-list-line"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="input">
                                        <div class="input-item">
                                            <select formControlName="biometric">
                                                <option value="" disabled selected>Select Bio Metrics</option>
                                                <option value="Access Door 1">Access Door 1</option>
                                                <option value="Access Door 2">Access door 2</option>
                                            </select>
                                            <label class="floating-label-special"> Bio Metrics</label>
                                            <i class="ri-user-line"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="input">
                                        <div class="input-item">
                                            <select formControlName="ismsTraining">
                                                <option value="" disabled selected>Select ISMS Training</option>
                                                <option [ngValue]="true">Yes</option>
                                                <option [ngValue]="false">No</option>
                                            </select>
                                            <label class="floating-label-special">ISMS Training*</label>
                                            <i class="ri-user-line"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="input">
                                        <div class="input-item">
                                            <select formControlName="ismsAgreement">
                                                <option value="" disabled selected>Select ISMS Agreement</option>
                                                <option [ngValue]="true">Yes</option>
                                                <option [ngValue]="false">No</option>
                                              </select>
                                              <label class="floating-label-special">ISMS Agreement*</label>
                                              <i class="ri-user-line"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="row">
                                    <div class="col-sm-6">
                                      <h5>Other Information</h5>
                                    </div> 
                                </div>
                                <div class="col-sm-6">
                                    <div class="input">
                                        <div class="input-item">
                                            <select formControlName="licenseAllocation">
                                                <option value="" disabled selected>Select license Allocation</option>
                                                <option value="Enterprise Mobility + Security E3">Enterprise Mobility + Security E3</option>
                                                <option value="Microsoft 365 Business Basic">Microsoft 365 Business Basic</option>
                                                <option value="Microsoft 365 Business Standard">Microsoft 365 Business Standard</option>
                                            </select>
                                            <label class="floating-label-special">License Allocation*</label>
                                            <i class="ri-user-line"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-6">
                                    <div class="input">
                                        <div class="input-item">
                                            <select formControlName="licenseRequired" >
                                                <option value="" disabled selected>Select License Requirement</option>
                                                <option [ngValue]="true">Yes</option>
                                                <option [ngValue]="false">No</option>
                                              </select>
                                              <label class="floating-label-special">License Requirement*</label>
                                              <i class="ri-user-line"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
  </div>